import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, formatError } from "@/lib/api";
import { PdfButton } from "@/components/admin/CoachingActions";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "—");

const ClientRow = ({ c, onArchive }) => (
  <div data-testid={`client-row-${c.id}`} className={`flex flex-wrap items-center justify-between gap-4 p-4 ${c.archived ? "opacity-60" : ""}`}>
    <div className="min-w-0">
      <p className="font-semibold">{c.name}</p>
      <p className="font-mono text-xs text-[#a3b1aa]">
        <a href={`mailto:${c.email}`} className="hover:text-[#c4dcca]">{c.email}</a> · <a href={`tel:${c.phone}`} className="hover:text-[#c4dcca]">{c.phone}</a>
      </p>
      <p className="mt-1 font-mono text-[11px] text-[#a3b1aa]">Pagato {c.pay_amount ?? 497} € il {fmt(c.paid_at)}</p>
    </div>
    <div className="flex flex-wrap items-center gap-4">
      <PdfButton c={c} />
      <label className="mt-3 flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa]">
        <Switch data-testid={`client-archive-${c.id}`} checked={!!c.archived} onCheckedChange={(v) => onArchive(c, v)} /> Percorso concluso
      </label>
    </div>
  </div>
);

export const ClientsPanel = () => {
  const [items, setItems] = useState([]);
  const [s, setS] = useState(null);
  const load = () => {
    api.get("/admin/coaching-checkups").then((r) => setItems((Array.isArray(r.data) ? r.data : []).filter((c) => c.pay_status === "pagato"))).catch(() => {});
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const archive = async (c, archived) => {
    try {
      await api.patch(`/admin/coaching-checkups/${c.id}`, { archived });
      toast.success(archived ? "Cliente archiviato: il posto torna libero" : "Cliente riattivato");
      load();
    } catch (e) {
      toast.error(formatError(e));
    }
  };
  const active = items.filter((c) => !c.archived);
  const done = items.filter((c) => c.archived);

  return (
    <div className="space-y-8" data-testid="clients-panel">
      <p className="max-w-2xl text-sm text-[#a3b1aa]">
        Qui trovi chi ha pagato l'iscrizione. {s && <span className="text-[#f4f7f5]" data-testid="clients-seats">Posti occupati {s.seats_taken} su {s.coaching_seats}.</span>} Quando un percorso finisce, segna «Percorso concluso»: il cliente viene archiviato e il posto torna libero per il gruppo successivo.
      </p>
      <section>
        <p className="mb-3 font-mono text-xs uppercase tracking-widest text-[#98bfa2]">Percorso in corso · {active.length}</p>
        {active.length === 0 && <p data-testid="clients-empty" className="text-sm text-[#a3b1aa]">Nessun cliente nel percorso attuale.</p>}
        <div className="divide-y divide-white/5 border border-[rgba(152,191,162,0.15)]">{active.map((c) => <ClientRow key={c.id} c={c} onArchive={archive} />)}</div>
      </section>
      {done.length > 0 && (
        <section>
          <p className="mb-3 font-mono text-xs uppercase tracking-widest text-[#a3b1aa]">Percorsi conclusi · {done.length}</p>
          <div className="divide-y divide-white/5 border border-white/10">{done.map((c) => <ClientRow key={c.id} c={c} onArchive={archive} />)}</div>
        </section>
      )}
    </div>
  );
};
